import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyCOP',
})
export class CurrencyCOPPipe implements PipeTransform {
  /**
   * Agarra el valor, por ejemplo 10000000 que en realidad es 100000,00 y le quito esos 2 digitos extras al final
   * y lo muestro como currency COP
   * @param value Valor en tipo numero que llega con digitos extras sin separador de decimales
   */
  transform(value: any, option?): any {
    value = value.toString();
    if (value !== 0) {
      if (option == 1) {
        value = value.slice(0, -2);
      }
      value = parseInt(value, 10);

      const currency = value
        .toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
        .replace(/,/g, '.');

      return currency;
    } else {
      return value.replace(/,/g, '.');
    }
  }
}
